// extracted by mini-css-extract-plugin
export default {"tabs":"expertize-wrapper_tabs__ARGvO","tab":"expertize-wrapper_tab__UCLit","active":"expertize-wrapper_active__qe3Nw"};